import { render, staticRenderFns } from "./supplierQuotationsAlarmStock.vue?vue&type=template&id=18e9bfbc&"
import script from "./supplierQuotationsAlarmStock.vue?vue&type=script&lang=js&"
export * from "./supplierQuotationsAlarmStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports